export const MONTANA_CONSTANTS = {
  DEFAULT_PARCELS: 406,
  // REPRICED 2026-08-27. Setup is now FLAT across tiers ($60/parcel both, so
  // $24,360 at 406 parcels) because the build is the same work either way.
  // Tiers differ on the monthly rate only. Must stay in step with the client
  // packet: 03-selection-sheet.md, 02-one-pager.md, slides.py and the video's
  // 09-tiers beat. This page is PUBLIC, so drift here contradicts the packet.
  PRICING: {
    SILVER: 8,
    GOLD: 10,
    // Custom pricing is quote-based
  },
  // Per-parcel setup fee rates (one-time), computed as rate * parcelCount
  SETUP_RATES_PER_PARCEL: {
    SILVER: 60, // $60 per parcel, FLAT with Gold since 2026-08-27
    GOLD: 60, // $60 per parcel
    // Custom setup is quote-based
  },
  // Deprecated: fixed setup fees replaced by per-parcel computation
  // Keeping for backward compatibility if referenced elsewhere
  SETUP_FEES: {
    SILVER: 24360, // For 406 parcels reference only (60 * 406)
    GOLD: 24360, // For 406 parcels reference only (60 * 406)
  },
  ANALOG_TO_DIGITAL: {
    ASSESSMENT_FEE: 500,
    HOURLY_RATES: {
      ORGANIZED: 75,
      MODERATE: 100,
      DISORGANIZED: 150,
    },
    MINIMUM_HOURS: 20,
  },
} as const;

export const MONTANA_THEME = {
  colors: {
    primary: {
      sage: '#87A96B',
      sky: '#4A90E2',
      earth: '#8B4513',
      snow: '#F8F8FF',
    },
    accent: {
      copper: '#B87333',
      wheat: '#F5DEB3',
      forest: '#228B22',
    },
    status: {
      success: '#10B981',
      warning: '#F59E0B',
      error: '#EF4444',
      info: '#3B82F6',
    },
  },
  gradients: {
    hero: 'linear-gradient(135deg, #4A90E2 0%, #87A96B 100%)',
    card: 'linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)',
  },
} as const;

export const BREAKPOINTS = {
  mobile: '320px',
  tablet: '768px',
  desktop: '1024px',
  large: '1440px',
} as const;

export const ANIMATION_DURATIONS = {
  fast: '150ms',
  normal: '300ms',
  slow: '500ms',
} as const;
